// Notification.js (or NotificationsBar.js, etc.)
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { hideNotification } from "../../store/Notifications/notificationsSlice";

export default function Notification() {
  const dispatch = useDispatch();
  const { open, message, type } = useSelector((state) => state.notifications);

  const handleClose = () => {
    dispatch(hideNotification());
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={3000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <Alert 
        onClose={handleClose} 
        severity={type} 
        variant="filled"
        sx={{
          '& .MuiAlert-action': {
            '& .MuiIconButton-root': {
              color: 'inherit'
            }
          }
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}
